// AuthContext.jsx
import Arc from '@/lib/Arc';
import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext(null); // Initialize with a default value (e.g., null)

const useAuth = () => useContext(AuthContext); // Custom hook for easy consumption

// AuthContext.js (continued)
const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Store user object or token
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // Indicate if auth status is being checked

  const [invalidateCounter, setInvalidateCounter] = useState(0);

  // Simulate an asynchronous check for authentication (e.g., from localStorage)
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      let user = JSON.parse(storedUser);
      if (user && user.access_token) {
        Arc(user.access_token).serviceCall(
          'guardian',
          'findGuardianByToken'
        ).then(res => {
          login(res.result)
          setLoading(false);
        }).catch(err => {
          setLoading(false);
          setUser(null);
          setIsAuthenticated(false);
        });
      }
    }

  }, []);

  useEffect(() => {
    console.log("[USEAUTH] Invalidating authenication counter.")
    if (user && user.access_token) {
      Arc(user.access_token).serviceCall(
        'guardian',
        'findGuardianByToken'
      ).then(res => {
        login(res.result)
        setLoading(false);
      }).catch(err => {
        setLoading(false);
        setUser(null);
        setIsAuthenticated(false);
      });
    }
  }, [invalidateCounter]);

  const invalidate = () => {
    setInvalidateCounter(invalidateCounter + 1);
  }

  const login = async (user) => {
    // Implement actual login logic (e.g., API call)
    const fetchedUser = user; // Example user data
    setUser(fetchedUser);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(fetchedUser));
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
  };

  const authContextValue = {
    user,
    isAuthenticated,
    loading,
    login,
    logout,
    invalidate
  };

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
}

export { useAuth, AuthProvider };